export function InputPhoneIcon({ ...props }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.362 1.69521C10.9045 1.15274 11.7917 1.17882 12.3013 1.7522L14.4803 4.20354C14.6256 4.36695 14.6891 4.58729 14.6532 4.80294C13.8114 9.85358 9.85358 13.8114 4.80295 14.6531C4.5873 14.6891 4.36695 14.6256 4.20355 14.4803L1.75221 12.3013C1.17882 11.7917 1.15275 10.9044 1.69522 10.362L3.4254 8.63179C3.91805 8.13914 4.70694 8.10885 5.23593 8.56226L6.75603 9.86521C8.05641 9.13169 9.1317 8.0564 9.86522 6.75603L8.56227 5.23592C8.10885 4.70694 8.13915 3.91804 8.6318 3.42539L10.362 1.69521ZM11.3048 2.63802L9.57461 4.3682L11.1537 6.21048C11.3399 6.42766 11.3777 6.73526 11.2498 6.9911C10.3284 8.83401 8.83402 10.3283 6.99111 11.2498C6.73526 11.3777 6.42767 11.3399 6.21049 11.1537L4.36821 9.5746L2.63803 11.3048L4.86768 13.2867C9.126 12.4587 12.4587 9.126 13.2867 4.86767L11.3048 2.63802Z"
        fill="currentColor"
      />
    </svg>
  );
}
